module.exports = __webpack_public_path__ + "img/play-mask-active@2x.86001bb7.png";